class ConfigController {
    constructor() {
        this.config = {
            locale: "en"
        };
        this.set = (config) => this.config = config;
    }
    get get() {
        return this.config;
    }
}
export const config = new ConfigController();
//# sourceMappingURL=index.js.map